import { render, staticRenderFns } from "./basic-profile.vue?vue&type=template&id=46a601a6&"
import script from "./basic-profile.vue?vue&type=script&lang=js&"
export * from "./basic-profile.vue?vue&type=script&lang=js&"
import style0 from "./basic-profile.vue?vue&type=style&index=0&id=46a601a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports